import { useEffect, useRef } from 'react';
import { registerBackLayer } from '../utils/backLayers';

export default function useBackLayer(onClose, open = true) {
  const latest = useRef(onClose);
  useEffect(() => { latest.current = onClose; }, [onClose]);
  useEffect(() => {
    if (open) return registerBackLayer(() => latest.current?.());
  }, [open]);
}
